import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ roles = [] }) {
  const location          = useLocation();
  const { isAuthenticated } = useSelector(s => s.auth);
  const user              = JSON.parse(localStorage.getItem('user') || '{}');

  /* 1 ── Not logged in → /login */
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  /* 2 ── Role gating */
  const allowed = roles.length === 0 || roles.includes(user.role);
  if (!allowed) {
    // redirect to a sensible default for THIS user
    if (user.role === 'admin')   return <Navigate to="/admin/dashboard"   replace />;
    if (user.role === 'member')  return <Navigate to="/member/dashboard"  replace />;
    if (user.role === 'company_admin')  return <Navigate to="/company/dashboard"  replace />;
    return <Navigate to="/403" replace />;
  }

  /* 3 ── Happy path */
  return <Outlet />;
}
